import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useRouter } from "@lib/hooks/useRouter";
import { REINITIALIZE_COOKIE_SETTINGS_KEY } from "@lib/constants";
declare global {
  interface Window {
    Cookiebot?: {
      show(isRenewal: boolean): void;
    };
  }
}
const useCookiebotRenewal = () => {
  const $ = _c(4);
  const router = useRouter();
  let t0;
  if ($[0] !== router?.events) {
    t0 = () => {
      const onHashChangeStart = _temp;
      router?.events?.on("hashChangeStart", onHashChangeStart);
      return () => {
        router?.events?.off("hashChangeStart", onHashChangeStart);
      };
    };
    $[0] = router?.events;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = router?.events;
  let t2;
  if ($[2] !== t1) {
    t2 = [t1];
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t0, t2);
};
export default useCookiebotRenewal;
function _temp(url) {
  const hash = url?.split("#")?.[1];
  if (hash === REINITIALIZE_COOKIE_SETTINGS_KEY) {
    if (window.Cookiebot) {
      window.Cookiebot.show(true);
    }
  }
}